/* eslint-disable no-undef */
import { InjectedConnector } from '@web3-react/injected-connector';

const supportedChainIds = process.env.REACT_APP_PRODUCT_ENV === 'mainnet' ? [56] : [97, 5777, 1337];

export const injected = new InjectedConnector({
  supportedChainIds
});
